var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40C9.83341 40 1.66675 31.8333 1.66675 21.6667C1.66675 12.1667 9.00008 4.33333 18.3334 3.33333V0H20.0001C26.8334 0 33.1667 3.16667 37.3334 8.66667L38.3334 10L35.6667 12C37.3334 15 38.3334 18.1667 38.3334 21.6667C38.3334 31.8333 30.1667 40 20.0001 40ZM18.3334 6.83333C10.8334 7.66667 5.00008 14 5.00008 21.6667C5.00008 30 11.6667 36.6667 20.0001 36.6667C28.3334 36.6667 35.0001 30 35.0001 21.6667C35.0001 19 34.3334 16.3333 33.0001 14L18.3334 25V6.83333ZM21.6667 3.33333V18.3333L33.6667 9.33333C30.5001 6 26.1667 3.83333 21.6667 3.33333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/AnalyticsIcon.31c336b0ed460bbf4bc95e2bf0fd91bf.svg";
export { ForwardRef as ReactComponent };